const supportCallbackKey = 'supportCallback';
const supportCallback = () => {
  window.Intercom('show');
};

const notificationCallbacks = {
  [supportCallbackKey]: supportCallback,
} as const;

const isExistingNotificationCallback = (value: string): value is keyof typeof notificationCallbacks => {
  return (Object.keys(notificationCallbacks) as readonly string[]).includes(value);
};

const getNotificationCallback = (callbackName: string) => {
  if (isExistingNotificationCallback(callbackName)) {
    return notificationCallbacks[callbackName];
  }
};

export { supportCallbackKey, supportCallback, getNotificationCallback };
